import axios from "axios";
import { headersProvider, masterApiHeader } from "../apiHelpers";
import constants from "../constants";

// export const getUserTasks = () => axios.get(`${constants.apiHost}/tasks/my-tasks`, {
//   headers: headersProvider(),
// });

export const createServiceProvider = ({ serviceProviderData }) =>
  axios.post(
    `${constants.apiHost}/service-providers/new`,
    {
      ...serviceProviderData,
    },
    {
      headers: headersProvider(),
    },
  );

export const updateServiceProvider = ({ serviceProviderData }) =>
  axios.put(
    `${constants.apiHost}/service-providers/update`,
    {
      ...serviceProviderData,
    },
    {
      headers: headersProvider(),
    },
  );

export const createOrg = ({ OrgData }) =>
  axios.post(
    `${constants.apiHost}/service-providers/organization`,
    {
      ...OrgData,
    },
    {
      headers: headersProvider(),
    },
  );
export const createBusinessUnit = ({ OrgData }) =>
  axios.post(
    `${constants.apiHost}/service-providers/businessunitSave`,
    {
      ...OrgData,
    },
    {
      headers: headersProvider(),
    },
  );
export const buUpdate = ({ orgData }) =>
  axios.put(
    `${constants.apiHost}/bu-update`,
    {
      ...orgData,
    },
    {
      headers: headersProvider(),
    },
  );

export const listServiceProviders = ({
  page,
  filterOptions = null,
  sortByOptions = null,
}) =>
  axios.post(
    `${constants.apiHost}/service-providers/list`,
    {
      page,
      filterOptions,
      sortByOptions,
    },
    {
      headers: headersProvider(),
    },
  );

export const serviceAnalytics = () =>
  axios.get(`${constants.apiHost}/service-providers/analytics`, {
    headers: headersProvider(),
  });

export const getBussinessUnit = (signal) =>
  axios.get(`${constants.masterApi}/base-backend/business-unit/all`, {
    headers: masterApiHeader(),
    signal,
  });

export const serviceProviderLoginApi = ({ email, password }) =>
  axios.post(
    `${constants.masterApi}/base-backend/auth/sp-login`,
    {
      email,
      password,
    },
    {
      headers: headersProvider(),
    },
  );

// export const updatePasswordApi = ({oldPassword, newPassword, id}) => axios.post(`${constants.apiHost}/updatepassword/${id}`, {
//   oldPassword, newPassword
// }, {
//   headers: headersProvider(),
// });
export const updatePasswordApi = (data) =>
  axios.post(`${constants.masterApi}/base-backend/user/update-password`, data, {
    headers: headersProvider(),
  });

// export const resetPasswordAPI = ({
//   email
// }) => axios.post(`${constants.apiHost}/resetpassword`, {
//   email,
// }, {
//   headers: headersProvider(),
// });

export const resetPasswordAPI = (data) =>
  axios.post(`${constants.masterApi}/base-backend/user/reset-password`, data, {
    headers: headersProvider(),
  });

export const serviceProviderDetailsApi = ({ serviceProviderId }) =>
  axios.get(
    `${constants.apiHost}/service-providers/details/${serviceProviderId}`,
    {
      headers: headersProvider(),
    },
  );

export const serviceProviderExpensesApi = ({ serviceProviderId }) =>
  axios.get(
    `${constants.apiHost}/service-providers/expenses/${serviceProviderId}`,
    {
      headers: headersProvider(),
    },
  );
export const serviceProviderUserRole = () =>
  axios.get(`${constants.apiHost}/service-providers/user-roles/`, {
    headers: headersProvider(),
  });

export const serviceProviderOrganisation = () =>
  axios.get(`${constants.apiHost}/service-providers/organizationList`, {
    headers: headersProvider(),
  });
export const getUserRolesUsingRoleId = (roleId) =>
  axios.get(`${constants.masterApi}/base-backend/user/by-role/${roleId}`, {
    headers: headersProvider(),
  });

export const disableBu = ({ buId }) =>
  axios.put(
    `${constants.apiHost}/disablebu`,
    { buId },
    {
      headers: headersProvider(),
    },
  );

// export const getUserDetail = ({id})=>{
//   axios.get(`${constants.apiHost}/getUser/${id}`, {
//     headers: headersProvider(),
//   });
// }

export const setSpStatus = ({ enabled, serviceProviderId }) =>
  axios.put(
    `${constants.apiHost}/service-providers/set-enabled/${serviceProviderId}`,
    {
      enabled,
    },
    {
      headers: headersProvider(),
    },
  );
